const Distributors = {
    VANDELAY_COMPANY_ID: '60d613ea-c3db-4265-9a46-442553c8619a',

    CHURN_IMMEDIATELY: 'CHURN-IMMEDIATELY',
    CHURN_SET: 'CHURN-SET',
    CHURN_UNSET: 'CHURN-UNSET',
};

export default Distributors;
